var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper bg-white min-h-screen"},[_c('header',{staticClass:"sticky pin-t"},[_c('div',{staticClass:"blue-gradient hat relative"}),_c('Nav')],1),_c('main',{staticClass:"bg-white z-0"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }